export default function ShakeHands() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
            <path
                d="M30.8 23.5998L21.4285 32.9713C20.6395 33.7603 19.3603 33.7603 18.5713 32.9713L7.39981 21.7998C4.41745 18.8174 4.41744 13.982 7.39981 10.9997V10.9997C10.3822 8.01729 15.2175 8.01729 18.1999 10.9997L19.9999 12.7997"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M16.4396 20.1276C15.4291 19.1677 15.4029 17.5654 16.3814 16.5729L21.8193 11.0572C24.7847 8.04933 29.6324 8.03212 32.6191 11.0188V11.0188C35.5909 13.9906 35.5909 18.8088 32.6191 21.7806L30.8 23.5998L23.5999 16.3997L19.9166 20.083C18.9614 21.0382 17.419 21.058 16.4396 20.1276V20.1276Z"
                stroke="#F7A40A"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M23.5999 30.7996L20.8999 28.0996" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M27.2003 27.2L24.5002 24.5" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}
